// @flow
/** @jsx h */
import { h } from 'preact';

import Button from 'preact-material-components/Button';
import 'preact-material-components/Button/style.css';
import Dialog from 'preact-material-components/Dialog';
import 'preact-material-components/Dialog/style.css';
import { useState, useEffect } from 'preact/hooks';
import { useErrorModalContextDispatch } from '../../storeProviders/errorModalStore';
import type { ErrorModalType } from '../../storeProviders/errorModalStore';

export default function ErrorModal({
  title,
  message,
  handleClose,
  closeButtonText = 'Exit',
  isRetryAllowed = false,
  hideCloseButton = false,
  onRetryClick,
  retryButtonText,
}: ErrorModalType) {
  const [open, setOpen] = useState(false);
  const errorModalDispatch = useErrorModalContextDispatch();

  useEffect(() => {
    if (title) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [title]);

  const handleCloseModal = () => {
    setOpen(false);
    errorModalDispatch({
      type: 'MODAL/CLOSE',
    });
    if (onRetryClick) {
      onRetryClick();
    }
  };

  return (
    <div>
      <Dialog open={open}>
        <Dialog.Header>{title}</Dialog.Header>
        <Dialog.Body>{message}</Dialog.Body>
        <Dialog.Footer>
          {isRetryAllowed && (
            <Dailog.FooterButton cancel onClick={() => handleCloseModal()}>
              {retryButtonText ? retryButtonText : 'Ok'}
            </Dailog.FooterButton>
          )}
          {!hideCloseButton && (
            <Dailog.FooterButton
              accept
              onClick={() => {
                setOpen(false);
                handleClose();
              }}>
              {closeButtonText}
            </Dailog.FooterButton>
          )}
        </Dialog.Footer>
      </Dialog>
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/errorModal/index.js